









































































import Vue from "vue"
import PBottomSlideModal from "~/components/custom/bottomSlideModal/PBottomSlideModal.vue"
import ConversionButton from "~/components/guideline/button/ConversionButton.vue"
import MaterialIcon, {
  OUTLINED,
  FILLED,
} from "~/components/guideline/icon/MaterialIcon.vue"

export default Vue.extend({
  components: {
    PBottomSlideModal,
    MaterialIcon,
    ConversionButton,
  },
  props: {
    isApplying: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    iconType() {
      return { OUTLINED, FILLED }
    },
    message: {
      get(): string {
        return this.$clStores.projectApplyMessage.getters.applyMessage
      },
      set(newMessage: string) {
        this.$clStores.projectApplyMessage.actions.updateProjectApplyMessage(
          newMessage
        )
      },
    },
    isShownProjectApplyPanel(): boolean {
      return this.$clStores.projectApplyMessage.getters.isShownProjectApplyPanel
    },
    isApplicable(): boolean {
      return this.$clStores.projectApplyMessage.getters.isApplicable
    },
  },
  methods: {
    handleClickExpandIcon() {
      this.$emit("click-expand-icon")
    },
    handleClickSendButton() {
      this.$emit("click-send-message-button")
    },
    handleClickProfileButton() {
      this.$nuxt.$router.push({ path: "/profiles/edit/self_introduction" })
    },
  },
})
